import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { resetUserPassword, validateToken } from "../../services/user.service"
import InputLabel from "../common/InputLabel"
import InputPassword, { PasswordValidation } from "../common/InputPassword"
import ActionButton from "../common/ActionButton"
import { userPasswordResetForm } from "../../models/user.model"
import useToken from "../../hooks/useToken"
import useUser from "../../hooks/useUser"
import './index.css'
import { useNotification } from "../../context/NotificationContext"


interface UserPasswordResetProps {
  token: string,
  setBlockScreen: (param: boolean) => void
}

export default function UserPasswordReset({ token, setBlockScreen }: UserPasswordResetProps) {

  const navigate = useNavigate()
  const { showNotification } = useNotification();

  const { setToken } = useToken()
  const { setUser } = useUser()

  const [userPasswordForm, setUserPasswordForm] = useState<userPasswordResetForm>({
    name: '',
    username: '',
    password: '',
    confirm_password: ''
  })

  const initComponent = () => {
    Promise.all([validateToken(token)]).then(function (results) {
      setUserPasswordForm(({ ...userPasswordForm, ...results[0] }))
    }).catch((error) => {
      navigate('/not-found')
    })
  }

  useEffect(initComponent, [])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setUserPasswordForm({
      ...userPasswordForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSubmit = () => {
    setBlockScreen(true)
    Promise.all([resetUserPassword(userPasswordForm)])
      .then(() => {
        setBlockScreen(false)
        setUser(null)
        setToken(null)
        navigate('/')
      })
      .catch((error: any) => {
        showNotification(error.response.data, 'error')
        setBlockScreen(false)
      })
  }

  const [validationPassword, setValidationPassword] = useState<boolean>(false)

  return (<>
    <div className='user-password-reset-box-wrap'>

      <div className='user-password-reset-box'>
        <div className="user-password-reset-title">
          <div>
            Elige un password
          </div>
        </div>

        <form className="user-password-reset-fields">

          <InputLabel
            label='Usuario'
            value={userPasswordForm.name}
            disabled
          />

          <InputLabel
            label='Nombre de Usuario'
            value={userPasswordForm.username}
            disabled
          />

          <InputPassword
            label='Nueva contraseña'
            name='password'
            value={userPasswordForm.password}
            onChange={handleChange}
            showEye
          />

          <InputPassword
            label='Confirma nueva contraseña'
            name='confirm_password'
            value={userPasswordForm.confirm_password}
            onChange={handleChange}
            showEye
          />

          <span className="user-password-reset-validation">
            <PasswordValidation
              inputPassword={userPasswordForm.password}
              confirmPassword={userPasswordForm.confirm_password}
              setValidationSuccess={setValidationPassword}
            />
          </span>
        </form>

        <span>
          <ActionButton
            text="Confirmar"
            type="confirm"
            onClick={handleSubmit}
            disabled={!validationPassword}
          />
        </span>

      </div>
    </div>

  </>)
}